module.exports = __webpack_public_path__ + "static/img/A118.e5caf2c0.jpg";